import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
const askInputModelSelectorOpenedEvent = EVENT_PAYLOAD;
const askInputModelSelectedEvent = EVENT_PAYLOAD;
/** The model picker's product analytics; every input hosting `SearchModelMenu` reports these two events. */
export function useAskInputModelSelectorAnalytics({ querySource, searchModelProps, selectedSearchMode, enabled, }) {
    const { track } = useInstrumentation();
    const trackModelSelectorOpened = useCallback(() => {
        if (!enabled) {
            return;
        }
        if (searchModelProps.multiple) {
            track(askInputModelSelectorOpenedEvent({
                name: 'ask input model selector opened',
                data: {
                    querySource,
                    searchMode: selectedSearchMode,
                    multiple: true,
                    selectedModels: searchModelProps.models,
                },
            }));
            return;
        }
        track(askInputModelSelectorOpenedEvent({
            name: 'ask input model selector opened',
            data: {
                querySource,
                searchMode: selectedSearchMode,
                multiple: false,
                selectedModel: searchModelProps.model,
            },
        }));
    }, [enabled, querySource, searchModelProps, selectedSearchMode, track]);
    const trackModelSelectionAttempt = useCallback(({ model, gated, selectedModels }) => {
        if (!enabled) {
            return;
        }
        if (searchModelProps.multiple) {
            track(askInputModelSelectedEvent({
                name: 'ask input model selected',
                data: {
                    querySource,
                    searchMode: selectedSearchMode,
                    multiple: true,
                    previousModels: searchModelProps.models,
                    selectedModels: selectedModels ?? searchModelProps.models,
                    gated,
                },
            }));
            return;
        }
        track(askInputModelSelectedEvent({
            name: 'ask input model selected',
            data: {
                querySource,
                searchMode: selectedSearchMode,
                multiple: false,
                previousModel: searchModelProps.model,
                selectedModel: model,
                gated,
            },
        }));
    }, [enabled, querySource, searchModelProps, selectedSearchMode, track]);
    return useMemo(() => ({ trackModelSelectorOpened, trackModelSelectionAttempt }), [trackModelSelectorOpened, trackModelSelectionAttempt]);
}
//# sourceMappingURL=useAskInputModelSelectorAnalytics.js.map